import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=68c9f184"
import script from "./Invitation.vue?vue&type=script&lang=js"
export * from "./Invitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports